define('controllers/memberservices/myCommodityList',['app', 'mainCons'], function (app, mainCons) {
    app.controller('MyCommodityList', ['$scope', '$q', '$rootScope', '$state', '$location', 'UserInfo', 'auiDialog', 'paidMemberService', 'commonUtils',
        function ($scope, $q, $rootScope, $state, $location, UserInfo, auiDialog, paidMemberService, commonUtils) {
            var Model = $scope.Model = {
                commodityList :[],
                mySubscriptionList:[],
                myEffectList : [],
                myExpireList : [],
                myUnsubscribeList:[],
                myUnsubscribeingList:[],
                selectCommodity :'',
                isDetailActive :true,
                commodityMutexList : {},
                commodityAssetList : [],
                commodityVectorList:[],
                commodityStatus:{},
                messagePagination:{currentPage: 1, itemsPerPage: 10, totalCount: 0, noItems: "No products", pagesLength: 5, onChange: getUserOrderList,perPageOptions:[10,20,50]},
                userOrderList:[],
                orderStatus : mainCons.commodityConstant.orderStatus,
                orderType : mainCons.commodityConstant.orderType,
                commodityCycle : mainCons.commodityConstant.commodityCycle,
                showUnit : mainCons.commodityConstant.showUnit,
                currencyType : mainCons.commodityConstant.currencyType,
                effectiveType : mainCons.commodityConstant.effectiveType,
                renewType : mainCons.commodityConstant.renewType,
                repeatOrder : mainCons.commodityConstant.repeatOrder,
                limitPeriodType : mainCons.commodityConstant.limitPeriodType,
                showSignAgreeSign : false
            };

            $scope.clickTab = clickTab;
            $scope.goDetail = goDetail;
            $scope.goOrderPlan = goOrderPlan;
            $scope.updateAutoRenew = updateAutoRenew;//更新续订标识
            $scope.orderPlan = orderPlan;
            $scope.goBack = goBack;
            $scope.showAgreement = showAgreement;

            init();

            function init() {
                //查询自己购买的套餐
                paidMemberService.getUserSubscriptionList().then(function(u){
                    if(u && u.userSubscriptionList && u.userSubscriptionList.length > 0 ){
                        for(var j in u.userSubscriptionList){
                            var userSubscription = u.userSubscriptionList[j];

                            //获取套餐的状态
                            paidMemberService.queryCommodityDetail(userSubscription.commodityID).then(function(data){
                                if(data && data.commodity4User) {
                                    Model.commodityStatus[data.commodity4User.commodityId] = data.commodity4User.commodityStatus;
                                }
                            });

                            userSubscription.autoRenewCheck = userSubscription.autoRenew == 1;

                            //生效的、退订中的，则需要存储互斥的套餐列表
                            if(userSubscription.status == 1 || userSubscription.status == 5){
                                Model.commodityMutexList[userSubscription.commodityID] = "true";
                            }
                            if(userSubscription.status == 1){
                                Model.myEffectList.push(userSubscription);
                            }
                            if(userSubscription.status == 5){
                                Model.myUnsubscribeingList.push(userSubscription);
                            }
                            if(userSubscription.status == 2){
                                Model.myUnsubscribeList.push(userSubscription);
                            }
                            if(userSubscription.status == 3){
                                Model.myExpireList.push(userSubscription);
                            }
                        }
                        orderByList(Model.myEffectList);
                        orderByList(Model.myUnsubscribeingList);
                        orderByList(Model.myUnsubscribeList);
                        orderByList(Model.myExpireList);
                    }
                });

                //判断是否签署过协议
                paidMemberService.getIsSignAgreement(mainCons.commodityConstant.argeementNo).then(function(signedData){
                    if(signedData)
                    {
                        // 签署状态。1：已签署最新版本；2：已签署非最新版本；3：未签署；
                        if (signedData.signStatus == 1 || (signedData.signStatus == 2 && signedData.isForcedSign != 'true')) {
                            Model.showSignAgreeSign = true;
                        }
                    }
                });
            }

            function orderByList(list){
                if(list.length > 0 ){
                    list.sort(function(a,b){
                        var date1 = new Date(a.expireTime);
                        var date2 = new Date(b.expireTime);
                        return date2.getTime() - date1.getTime();
                    });
                    Model.mySubscriptionList = Model.mySubscriptionList.concat(list);
                }
            }


            function updateAutoRenew(m) {
                var defer = $q.defer();
                var type = m.autoRenewCheck?2:1;
                paidMemberService.updateAutoRenew(m.subscriptionID,type).then(function(){
                    m.autoRenewCheck = !m.autoRenewCheck;
                    m.autoRenew = m.autoRenewCheck?1:2;
                    defer.resolve();
                }).catch(function () {
                    defer.reject();
                });
                return defer.promise;
            }


            function goDetail(selectCommodity){
                Model.isDetailActive = true;
                Model.selectCommodity = selectCommodity;
                Model.commodityPrice = {};
                Model.commodityLangCN = {};
                Model.commodity4User = {};
                Model.commodityAssetList = [];
                Model.commodityVectorList = [];

                paidMemberService.queryCommodityDetail(selectCommodity.commodityID).then(function(data){
                    document.getElementById("tab-03").scrollIntoView({behavior: "smooth"});
                    if(data && data.commodity4User){
                        var commodity4User = Model.commodity4User = data.commodity4User;
                        //取中文的价格信息
                        if(commodity4User.commodityPriceList){
                            for(var i in commodity4User.commodityPriceList){
                                if('CN' == commodity4User.commodityPriceList[i].regionType){
                                    Model.commodityPrice = commodity4User.commodityPriceList[i];
                                }
                            }
                        }

                        if(commodity4User.commodityLangList){
                            for(var j in commodity4User.commodityLangList){
                                if('zh_CN' == commodity4User.commodityLangList[j].lang){
                                    Model.commodityLangCN = commodity4User.commodityLangList[j];
                                }
                            }
                        }

                        if(commodity4User.commodityAssetList){
                            for(var k in commodity4User.commodityAssetList){
                                var commodityAsset = commodity4User.commodityAssetList[k];
                                for(var l in commodityAsset.assetLangList){
                                    if('zh_CN' == commodityAsset.assetLangList[l].lang){
                                        commodityAsset.assetLang = commodityAsset.assetLangList[l];
                                    }
                                }

                                //Vetor的权益，并且是可计量的权益，才去openAsset查询数据
                                if(commodityAsset.serviceDomain == 2){
                                    if(commodityAsset.isLimited == 1){
                                        //1.byte 2.MB 3.GB 4.TB 5.个 6.次
                                        if(commodityAsset.limitShowUnit == 2){
                                            commodityAsset.limitQuantity = commodityAsset.limitQuantity / 1024 /1024;
                                        }else if(commodityAsset.limitShowUnit == 3){
                                            commodityAsset.limitQuantity = commodityAsset.limitQuantity / 1024 / 1024 /1024;
                                        }else if(commodityAsset.limitShowUnit == 4){
                                            commodityAsset.limitQuantity = commodityAsset.limitQuantity / 1024 / 1024 / 1204 /1024;
                                        }
                                    }
                                    Model.commodityVectorList.push(commodityAsset);
                                }else{
                                    Model.commodityAssetList.push(commodityAsset);
                                }
                            }

                            paidMemberService.queryAsset(2,selectCommodity.subscriptionID).then(function(data1){
                                    if(data1.subscriptions && data1.subscriptions.length > 0){
                                        var subscription = data1.subscriptions[0];
                                        if(subscription.assets && subscription.assets.length > 0 ){
                                            var assetList = subscription.assets;
                                            for(var ass in assetList){
                                                Model.commodityVectorList.forEach(function(each){
                                                    if(each.assetId == assetList[ass].assetId){
                                                        each.defaultValue = assetList[ass].defaultValue;
                                                        each.assetValue = assetList[ass].assetValue;
                                                        each.measurable = assetList[ass].measurable;

                                                        //1.byte 2.MB 3.GB 4.TB 5.个 6.次
                                                        if(each.isPlural == 1){
                                                            if(each.showUnit == 2){
                                                                each.assetValue = each.assetValue / 1024 /1024;
                                                                each.defaultValue = each.defaultValue / 1024 /1024;
                                                            }else if(each.showUnit == 3){
                                                                each.assetValue = each.assetValue / 1024 / 1024 /1024;
                                                                each.defaultValue = each.defaultValue / 1024 / 1024 /1024;
                                                            }else if(each.showUnit == 4){
                                                                each.assetValue = each.assetValue / 1024 / 1024 / 1204 /1024;
                                                                each.defaultValue = each.defaultValue / 1024 / 1024 / 1204 / 1024;
                                                            }
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    }
                                }
                            );
                        }
                    }
                });

                //获得我的订单
                getUserOrderList(selectCommodity.subscriptionID);
            }

            function getUserOrderList(subscriptionID) {
                var baseReq = {
                    fromRecCount:1 + (Model.messagePagination.currentPage - 1) * Model.messagePagination.itemsPerPage,
                    maxReqCount:Model.messagePagination.itemsPerPage,
                    subscriptionID:subscriptionID?subscriptionID:Model.selectCommodity.subscriptionID};
                paidMemberService.getUserOrderList(baseReq).then(function(resp){
                    Model.userOrderList = resp.userOrderList?resp.userOrderList:[];
                    Model.messagePagination.totalCount = resp.totalCount;
                })
            }


            function goOrderPlan() {
                Model.isDetailActive =false ;
                $state.go('memberservices.UserOrderList', { subscriptionID : Model.selectMyComodityID});
            }

            function clickTab(){
                $state.go('memberservices.commodityList');
            }

            function orderPlan(type) {
                paidMemberService.orderPlan(Model.selectCommodity,type);
            }

            function goBack(){
                document.getElementById("tab-01").scrollIntoView();
            }

            function showAgreement(){
                commonUtils.showAgreement([mainCons.commodityConstant.argeementNo]);
            }
        }
    ]);
});

